module.exports = __webpack_public_path__ + "img/icon_right.236a8981.svg";